import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { EnvService } from 'src/app/services/env.service';
import { UserService } from '../../user.service';
import { UniversalStorageService } from '../../../services/universal-storage.service';

@Component({
    selector: 'app-profile-list',
    templateUrl: './profile-list.component.html',
    styleUrls: ['./profile-list.component.scss'],
})
export class ProfileListComponent implements OnInit {
    profileForm: FormGroup;
    activeItem: number;

    url = '';
    user_name: string | null;
    user_email: string;
    profile_picture: string;
    fullName: string | null;
    imis_id: string;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private env: EnvService,
        private userService: UserService,
        private storageService: UniversalStorageService
    ) {
        const token = this.storageService.getItem('BEARER_TOKEN');
        // Replace with your token storage mechanism
        if (token) {
            const tokenPayload = this.decodeToken(token);

            this.user_email = tokenPayload.data.email;
            //  this.username = tokenPayload.data.user_name;
            this.user_name = tokenPayload.data.user_name;
            this.imis_id = tokenPayload.data.imis_id;
        }
    }
    ngOnInit(): void {
        this.userService
            .getProfilePicture(this.user_email)
            .subscribe((response) => {
                if (
                    response &&
                    response['profile_picture'] &&
                    response['profile_picture']['user_profile_picture']
                ) {
                    this.profile_picture =
                        this.env.userProfile +
                        this.imis_id +
                        '/' +
                        response['profile_picture']['user_profile_picture'];

                    const firstname = response['profile_picture']['firstname'];
                    const lastname = response['profile_picture']['lastname'];
                    this.fullName = `${firstname} ${lastname}`;
                } else {
                    console.log(
                        'Profile picture or required properties not found in the response.'
                    );
                }
            });
    }

    private decodeToken(token: string) {
        const tokenParts = token.split('.');
        if (tokenParts.length !== 3) {
            throw new Error('Invalid token format');
        }

        const tokenPayload = JSON.parse(atob(tokenParts[1]));
        return tokenPayload;
    }

    activateItem(itemNumber: number): void {
        this.activeItem = itemNumber;

        let componentRoute = '';

        switch (itemNumber) {
            // case 1:
            //     componentRoute = 'user/user-profile/edit-profile';
            //     break;
            case 2:
                componentRoute = 'user/user-profile/edit-profile';
                break;
            case 3:
                componentRoute = 'user/user-profile/edit-photo';
                break;
            case 4:
                componentRoute = 'user/user-profile/edit-account';
                break;
            case 5:
                componentRoute = 'user/manage-subscriptions';
                break;
            case 6:
                componentRoute = 'user/user-profile/edit-payment-methods';
                break;
            case 7:
                componentRoute = 'user/user-profile/edit-notifications';
                break;
            case 8:
                componentRoute = 'user/user-profile/close-account';

            // Add more cases for other items as needed
        }

        // Navigate to the selected component route
        this.router.navigate([componentRoute]);
    }
}
